import React, { useEffect } from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import FieldInput from '../../form/FieldInput';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import Heading from '../../../common/heading/Heading';
import { validatePassword } from '../../../../helpers/validation';
import { deviceInformation } from '../../../../helpers/device';
import PasswordStrengthCheck from '../../common/passwordStrengthCheck/PasswordStrengthCheck';
import {
	NEXT,
	ONBOARDING_PASSWORD_TITLE,
	ONBOARDING_PASSWORD_FIELD,
} from '../../../../constants/Copy';

import focusDelay from '../../helpers/focusDelay';
import OnboardingProgress from '../../common/onboardingProgress/OnboardingProgress.container';

const warn = ({ password }) => ({
	password: <PasswordStrengthCheck password={password} />,
});

const validate = ({ password }) => ({
	password: validatePassword({ password }).valid ? (
		false
	) : (
		<PasswordStrengthCheck password={password} showErrors showPasswordStrengthCheck />
	),
});

const RegisterPassword = ({ submitting, handleSubmit, pristine, invalid }) => {
	let password = null;

	useEffect(() => {
		focusDelay(password, false);
	}, [password]);

	return (
		<form method="post" onSubmit={handleSubmit}>
			<OnboardingProgress activeStep={2} />
			<Heading>{ONBOARDING_PASSWORD_TITLE}</Heading>

			<Field
				element={(element) => (password = element)}
				name="password"
				type="password"
				autoFocus
				label={ONBOARDING_PASSWORD_FIELD}
				component={FieldInput}
				showPassword={deviceInformation.isMobile}
				autocomplete="new-password"
				testId="password-input"
				showPasswordStrengthCheck
			/>

			<Button
				loading={submitting}
				disabled={submitting || pristine || invalid}
				testId="password-button"
				type="submit"
			>
				{NEXT}
			</Button>
		</form>
	);
};

PropTypes.RegisterPassword = {
	handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
	form: 'register',
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate,
	warn,
})(RegisterPassword);
